import React, { Component } from 'react';
import Recaptcha from 'react-recaptcha';
import axios from 'axios';
import { withRouter } from 'react-router-dom';

class Contact extends Component {
    constructor(props) {
        super(props);
        this.state = {
            contact_name: '',
            contact_email: '',
            contact_phone: '',
            contact_message: '',
            isHuman: false,
            sending: false,
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.recaptchaLoaded = this.recaptchaLoaded.bind(this);
        this.recaptchaVerified = this.recaptchaVerified.bind(this);
    }

    handleChange(event) {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    }

    handleSubmit(event) {
        event.preventDefault();
        if (!this.state.isHuman) {
            alert('Please verify that you are a human!');
            return;
        }

        this.setState({ sending: true });
        this.props.history.push('/loading');

        axios.post('https://dcjyb7bdbg.execute-api.us-east-1.amazonaws.com/prod/email', {
            to_email: 'stivan.kitchoukov@gmail.com',
            subject: 'New Message from Kitchoukov Website',
            name: this.state.contact_name,
            email: this.state.contact_email,
            phone: this.state.contact_phone,
            message: this.state.contact_message,
        })
            .then(() => this.props.history.push('/Thanks'))
            .catch((err) => {
                console.error('Email send failed', err);
                this.props.history.push('/Error');
            });
    }

    recaptchaLoaded() {
        console.log('Captcha successfully loaded');
    }

    recaptchaVerified(response) {
        if (response) this.setState({ isHuman: true });
    }

    render() {
        const inputCls = 'w-full bg-bg-card border border-border-subtle rounded-lg px-4 py-2.5 text-ink-primary placeholder-ink-muted focus:outline-none focus:border-accent focus:ring-1 focus:ring-accent transition-colors';
        const labelCls = 'block text-sm font-medium text-ink-secondary mb-1.5';

        return (
            <div className="wrap">
                <section className="py-20 px-4 sm:px-6">
                    <div className="max-w-xl mx-auto">
                        <div className="text-center mb-10">
                            <h1 className="text-4xl sm:text-5xl font-bold text-ink-primary">Contact</h1>
                            <div className="mx-auto mt-3 h-1 w-12 bg-accent rounded-full"></div>
                            <p className="mt-4 text-ink-secondary">Have a project in mind or want to say hi? Drop me a note.</p>
                        </div>

                        <form onSubmit={this.handleSubmit} className="bg-bg-card border border-border-subtle rounded-2xl p-6 sm:p-8 shadow-card space-y-5">
                            <div>
                                <label className={labelCls} htmlFor="contact_name">Name</label>
                                <input type="text" value={this.state.contact_name} onChange={this.handleChange} className={inputCls} id="contact_name" tabIndex="1" placeholder="Your name *" name="contact_name" required />
                            </div>
                            <div>
                                <label className={labelCls} htmlFor="contact_email">Email</label>
                                <input type="email" value={this.state.contact_email} onChange={this.handleChange} className={inputCls} id="contact_email" tabIndex="2" placeholder="you@example.com *" name="contact_email" required />
                            </div>
                            <div>
                                <label className={labelCls} htmlFor="contact_phone">Phone</label>
                                <input type="text" value={this.state.contact_phone} onChange={this.handleChange} className={inputCls} id="contact_phone" tabIndex="3" placeholder="Optional" name="contact_phone" />
                            </div>
                            <div>
                                <label className={labelCls} htmlFor="contact_message">Message</label>
                                <textarea value={this.state.contact_message} onChange={this.handleChange} className={`${inputCls} min-h-[140px]`} id="contact_message" tabIndex="4" placeholder="Tell me about your project *" name="contact_message" required />
                            </div>

                            <Recaptcha
                                sitekey="6LelI4EUAAAAAOLSM1-3cAODKI_Fx4-r_hbxnH0J"
                                render="explicit"
                                onloadCallback={this.recaptchaLoaded}
                                verifyCallback={this.recaptchaVerified}
                            />

                            <button
                                type="submit"
                                disabled={this.state.sending}
                                className="w-full sm:w-auto px-6 py-2.5 rounded-lg bg-accent text-white font-semibold hover:bg-accent-hover disabled:opacity-50 transition-colors"
                            >
                                {this.state.sending ? 'Sending…' : 'Send'}
                            </button>
                        </form>
                    </div>
                </section>
            </div>
        );
    }
}

export default withRouter(Contact);
